module.exports = __webpack_public_path__ + "static/media/product_16.039c9b44.jpg";